// buildOptions builds a common function for all the various unit families to

import type { ConvertableUnit } from ".";

// display their options with consistent filtering applied
export const buildOptions = (unitList: ConvertableUnit[]) => {
  return (
    excludedUnits: ConvertableUnit[] | null = null
  ): ConvertableUnit[] => {
    return unitList.filter(u => !excludedUnits || !excludedUnits.includes(u));
  };
};
